module.exports = __webpack_public_path__ + "img/green_095.686e35a3.png";